export default __webpack_public_path__ + "static/media/error-check.ed6c2fae.svg";